import { CreateTenantRoleCommand, TenantRoleDto, UpdateTenantRoleCommand } from '@admin/app/api'
import { BaseDataStore } from '@admin/app/store/basedata.store'
import { roleService } from '@admin/services/role.service'
import { makeObservable, observable, runInAction } from 'mobx'

export class RoleStore extends BaseDataStore<TenantRoleDto> {
  permissions: string[] = []

  constructor() {
    super()
    makeObservable(this, {
      permissions: observable,
    })
  }

  async load() {
    const roles = await roleService.load()

    runInAction(() => {
      this.data = roles
    })
  }

  async createRole(request: CreateTenantRoleCommand) {
    await roleService.create(request)
  }

  async updateRole(request: UpdateTenantRoleCommand) {
    await roleService.update(request)
  }

  async deleteRole(id: number) {
    await roleService.delete(id)

    runInAction(() => {
      this.data = this.data.filter(role => role.id !== id)
    })
  }

  async loadPermissions() {
    const permissions = await roleService.loadPermissions()
    runInAction(() => {
      this.permissions = permissions
    })
  }
}
